/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCompleted = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15.3 5.3 6 14.6l-3.3-3.3-1.4 1.4L6 17.4 16.7 6.7zm6 0L11 15.6l-.8-.8-1.4 1.4 2.2 2.2L22.7 6.7z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCompleted as Completed };
